import type { AgendaProject, ProjectRowView } from '@/shared/types/domain';

/**
 * A projeção reduzida vestida de linha de tabela (spec-calendar.md §3.3, §5.1).
 *
 * **Os nulos aqui não são preguiça — são a projeção.** `responsible_name` ficou
 * de fora da RPC de propósito (é decisão de privacidade separada, §3.3 e §13
 * item 3), e `submitted_at`/`decided_at` também: os dois só existem para contar
 * tempo de espera, e compromisso aprovado não está esperando ninguém.
 *
 * A consequência na tela é exatamente a desejada, sem tratamento especial em
 * lugar nenhum: a coluna "Responsável" mostra "—", e `waitingOf` devolve `null`,
 * então a coluna "Tempo de espera" nem chega a existir naquela tabela.
 */
export function toProjectRow(project: AgendaProject): ProjectRowView {
  return {
    id: project.id,
    title: project.title,
    status: project.status,
    starts_at: project.starts_at,
    ends_at: project.ends_at,
    ministry_id: project.ministry_id,
    ministry_name: project.ministry_name,
    coordination_id: project.coordination_id,
    coordination_name: project.coordination_name,
    space_names: project.space_names,
    responsible_name: null,
    submitted_at: null,
    decided_at: null,
  };
}
